import create from "zustand";

const useTingStore = create((set) => ({
    tingDoc: {},
    setTingDoc: (tingDoc) => set((state) => ({ tingDoc })),

}));

export default useTingStore;
